import TranslationNS from '@/utils/Constants/TranslationNS'

const MY = TranslationNS.MY_COMPETITIONS

/**
 * « My events » tour (William, 29 Oct 2026: « expliquer comment changer de rôle et accéder aux
 * actions d'un événement en fonction du rôle de l'utilisateur »): the head, the role filter, the
 * search, « Create an Event », then the first card: its role selector (only on a card held under
 * several roles) and its « ⋯ » actions, which follow the chosen role. A site tour on an absolute route.
 */
export const MY_EVENTS_TOUR = {
    id: 'my-events',
    version: 1,
    routes: ['/my-events'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="my-head"]',
            placement: 'bottom',
            title: 'All your events',
            description:
                'Every event you have a role in: organizer, athlete, volunteer, judge, spectator… One card per event, the organizer role first.',
        },
        {
            key: 'role',
            target: '[data-tour="my-role"]',
            placement: 'bottom',
            placementNarrow: 'bottom',
            title: 'Change role',
            description:
                '« All » shows each event with every role you hold on it. Pick a role to keep only those events; the choice stays in the page address, so you can bookmark it.',
        },
        {
            key: 'search',
            target: '[data-tour="my-search"]',
            placement: 'bottom',
            title: 'Find an event',
            description: 'Filters the cards by name or discipline while you type.',
        },
        {
            key: 'create',
            target: '[data-tour="my-create"]',
            placement: 'bottom',
            placementNarrow: 'bottomLeft',
            title: 'Create an event',
            description: 'Opens the creation of a new event: name, dates, discipline, then its page.',
        },
        {
            key: 'card',
            target: '[data-tour="my-card"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'The card of an event',
            description:
                'The band tells where the event stands: coming up, in progress or finished. At the bottom, whether its page is published. Click the card to open the event page.',
        },
        {
            key: 'card-role',
            target: '[data-tour="my-card-role"]',
            placement: 'bottom',
            placementNarrow: 'bottomLeft',
            title: 'Your role on this card',
            description:
                'When you hold several roles on the same event, this selector picks the one whose actions you want. With a single role, it is simply shown.',
        },
        {
            key: 'card-actions',
            target: '[data-tour="my-card-actions"]',
            // five entry lines: the card goes under the head so the bubble has the room below (phones)
            scroll: 'start',
            placement: 'bottomRight',
            placementNarrow: 'bottom',
            title: 'The actions of the event',
            description: 'The « ⋯ » button opens the actions of the chosen role:',
            entries: [
                {
                    label: 'Organizer',
                    ns: MY,
                    text: '« Dashboard » opens your organizer space: settings, registrations, planning, scores.',
                },
                {
                    label: 'Athlete',
                    ns: MY,
                    text: 'contract, leaderboard, planning, your registration, photos, review, claim.',
                },
                { label: 'Volunteer', ns: MY, text: 'contract, planning, your application.' },
                { label: 'Judge', ns: MY, text: 'the judge app once the organizer turns it on, contract, planning.' },
                { label: 'Check-in', ns: MY, text: 'athletes and volunteers check-in.' },
            ],
        },
    ],
}

export default MY_EVENTS_TOUR
